import { ModuleCardProps } from "./ModuleCard.interfaces"
import { Button } from '@netfront/ui-library';
import { ProgressCircle } from '../ProgressCircle';
import { getValidClassNames } from "@/utils";
import { format } from "date-fns";

export const ModuleCard = ({ additionalClassNames, href, icon, isLocked, openDate, percentageComplete = 0, progressIndicator, subTitle, summary, title }: ModuleCardProps) => {
  return( 
    <div className={getValidClassNames({
      "flex flex-col flex-1 h-full rounded-lg shadow overflow-hidden": true,
      [String(additionalClassNames)]: Boolean(additionalClassNames),
      'cursor-not-allowed': Boolean(isLocked)
    })}>
      {icon && (
        <div className="p-6 pb-12">
          <div
            className="bg-no-repeat bg-center bg-cover mx-auto rounded-circle w-36 h-36 shadow border-3 border-white"
            style={{ backgroundImage: `url(${icon})` }}
          />
        </div>
      )}

      <div 
        className={getValidClassNames({
          "bg-white relative flex flex-col flex-1 p-4 pt-12": true,
          'events-none': Boolean(isLocked)
        })}
      >
        <div className="absolute left-1/2 top-0 -translate-1/2">
          <ProgressCircle 
            isLocked={isLocked}
            percentageCompleted={percentageComplete} 
            styles={{ 
              ...progressIndicator
            }}
          />
        </div>

        <p className="font-heading text-center mb-0">{subTitle}</p>
        <p className="text-2xl weight-700 text-center mb-6">{title}</p>

        {isLocked && openDate && (
          <div className="text-center mb-4">
            <div className="bg-grey-300 rounded-full color-black inline-flex px-3 text-sm border border-grey-500">
              Opens: {format(openDate, 'dd/MM/yy')}
            </div>
          </div>
        )}

        <div className="flex flex-col mt-auto">
          {summary && (
            <Button
              additionalClassNames='flex-1 c-spotlight--summary'
              linkButton={{ id: `summary-${title}`, url: summary }}
              variant="primary-inverse"
              size="small"
              text='Summary'
              isDisabled={Boolean(isLocked)}
            />
          )}

          <Button
            additionalClassNames={getValidClassNames({
              'w-full mt-2': true,
              'c-spotlight--review': percentageComplete === 100
            })}
            linkButton={{ id: `module-${title}`, url: href }}
            variant={percentageComplete === 0 ? 'primary-inverse' : percentageComplete === 100 ? 'primary-inverse' : 'tertiary'}
            text={isLocked ? 'Locked' : percentageComplete === 0 ? 'Begin' : percentageComplete === 100 ? 'Review' : 'Continue'}
            isDisabled={Boolean(isLocked)}
          />
        </div>
      </div>
    </div>
  )
};